export default __webpack_public_path__ + "static/media/bodrumqueen2.84d079e5.jpg";